import { render, staticRenderFns } from "./CreateTripPage.vue?vue&type=template&id=d620da16&scoped=true&"
import script from "./CreateTripPage.vue?vue&type=script&lang=js&"
export * from "./CreateTripPage.vue?vue&type=script&lang=js&"
import style0 from "./CreateTripPage.vue?vue&type=style&index=0&id=d620da16&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d620da16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d620da16')) {
      api.createRecord('d620da16', component.options)
    } else {
      api.reload('d620da16', component.options)
    }
    module.hot.accept("./CreateTripPage.vue?vue&type=template&id=d620da16&scoped=true&", function () {
      api.rerender('d620da16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Trips/CreateTripPage.vue"
export default component.exports